import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Modal from "react-modal";
import Sidebar from "../componenteExtra/SidebarSolicitante";
import "../App2.css";
import { Toaster, toast } from "react-hot-toast";
import SessionManager from '../componenteExtra/SessionManager';
import * as XLSX from "xlsx";   // ← Nueva importación

Modal.setAppElement("#root");

const SolicitudesCreadasGET = () => {
  const [assignments, setAssignments] = useState([]);
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [singleCancelModalIsOpen, setSingleCancelModalIsOpen] = useState(false);
  const [cancelComment, setCancelComment] = useState("");
  const [singleCancelId, setSingleCancelId] = useState(null);
  const [editDatesModalIsOpen, setEditDatesModalIsOpen] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [newDates, setNewDates] = useState({
    fechaEntregaInformacion: "",
    fechaTerminoSolicitud: "",
    fechaDeInicio: "",
    fechaDeTermino: "",
  });
  const [nombre_get, setNombreGet] = useState("");

  const token = localStorage.getItem("access_token");
  const selectAllRef = useRef(null);

  // Filtros
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilial, setSelectedFilial] = useState("");
  const [selectedEstadoAsignacion, setSelectedEstadoAsignacion] = useState("");
  const [selectedEstadoStaff, setSelectedEstadoStaff] = useState("");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [selectedSolicitante, setSelectedSolicitante] = useState("");

  useEffect(() => {
    const storedNombreGet = localStorage.getItem("nombre_get");
    if (storedNombreGet) setNombreGet(storedNombreGet);
  }, []);

  const fetchAssignments = () => {
    if (!nombre_get) return;
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/get_all_assignments/${nombre_get}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setAssignments(res.data);
        setSelectedIds(new Set());
      })
      .catch((err) => {
        console.error("Error fetching assignments:", err);
        toast.error("Error al cargar solicitudes");
      });
  };

  useEffect(() => {
    if (nombre_get) fetchAssignments();
  }, [nombre_get]);

  // === EXPORTAR A EXCEL ===
  const exportToExcel = () => {
    if (filteredAssignments.length === 0) {
      toast.error("No hay datos para exportar");
      return;
    }

    const dataForExcel = filteredAssignments.map((a) => ({
      "Código proyecto": a.codigo_proyecto || "",
      "Nombre proyecto": a.nombre_proyecto || "",
      "Razón Social": a.razon_social || "",
      "Filial": a.filial || "",
      "Tipo de trabajo": a.tipo_solicitud || "",
      "Regulación": a.tipo_regulacion || "",
      "Rubro GET": a.rubro_get || "",
      "Nombre actividad GET": a.nombre_actividad_get || "",
      "Grupo": a.numero_grupo || "",
      "Jefe de grupo": a.jefe_grupo || "",
      "Subrogante": a.subrogante || "",
      "Fecha entrega info": a.fecha_entrega_informacion || "",
      "Fecha término solicitud": a.fecha_termino_senior_actividad || "",
      "Fecha emisión final": a.fecha_emision || "",
      "Staff asignado": a.staff_asignado || "",
      "Nombre solicitante": a.nombre_solicitante || "",
      "Fecha de inicio": a.fecha_de_inicio || "",
      "Fecha de término": a.fecha_de_termino || "",
      "Fecha corte auditoría": a.fecha_corte_auditoria || "",
      "Horas GET": a.horas_get || "",
      "Horas estándar": a.horas_estandar || "",
      "Estado asignación": a.estado_asignaciones || "",
      "Estado staff": a.estados_staff || "",
      "Actividad pausada": a.pausa || "",
      "Explicación pausa": a.definicion_pausa || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Solicitudes");

    const today = new Date().toISOString().split("T")[0];
    const fileName = `Solicitudes_${nombre_get || "GET"}_${today}.xlsx`;

    XLSX.writeFile(workbook, fileName);
    toast.success(`Descargado: ${filteredAssignments.length} filas`);
  };

  // === SELECCIÓN MASIVA ===
  const toggleSelect = (id) => {
    const newSelected = new Set(selectedIds);
    if (newSelected.has(id)) newSelected.delete(id);
    else newSelected.add(id);
    setSelectedIds(newSelected);
  };

  const toggleSelectAll = () => {
    if (selectedIds.size === filteredAssignments.length) {
      setSelectedIds(new Set());
    } else {
      setSelectedIds(new Set(filteredAssignments.map(a => a.id)));
    }
  };

  // === ANULACIÓN MASIVA ===
  const openCancelModal = () => {
    if (selectedIds.size === 0) {
      toast.error("Seleccione al menos una actividad para anular");
      return;
    }
    setCancelComment("");
    setModalIsOpen(true);
  };

  const closeCancelModal = () => {
    setModalIsOpen(false);
    setCancelComment("");
  };

  const handleBulkCancel = async () => {
    if (!cancelComment.trim()) {
      toast.error("Ingrese un motivo de anulación");
      return;
    }

    const toastId = toast.loading(`Anulando ${selectedIds.size} actividad(es)...`);

    try {
      const cancelPromises = Array.from(selectedIds).map(id =>
        axios.put(
          `${process.env.REACT_APP_BACKEND_URL}/cancel_assignment/${id}`,
          null,
          {
            params: { motivo_cancelacion: cancelComment },
            headers: { Authorization: `Bearer ${token}` },
          }
        )
      );

      await Promise.all(cancelPromises);

      toast.dismiss(toastId);
      toast.success(`${selectedIds.size} actividad(es) anulada(s)`);

      setAssignments(prev =>
        prev.map(a =>
          selectedIds.has(a.id)
            ? { ...a, estado_asignaciones: 6, motivo_cancelacion: cancelComment }
            : a
        )
      );

      setSelectedIds(new Set());
      closeCancelModal();
      setTimeout(fetchAssignments, 1000);
    } catch (error) {
      toast.dismiss(toastId);
      toast.error("Error al anular algunas actividades");
      console.error(error);
    }
  };

  // === ANULACIÓN INDIVIDUAL ===
  const openSingleCancelModal = (id) => {
    setSingleCancelId(id);
    setCancelComment("");
    setSingleCancelModalIsOpen(true);
  };

  const closeSingleCancelModal = () => {
    setSingleCancelModalIsOpen(false);
    setSingleCancelId(null);
    setCancelComment("");
  };

  const handleSingleCancel = async () => {
    if (!cancelComment.trim()) {
      toast.error("Ingrese un motivo de anulación");
      return;
    }

    const toastId = toast.loading("Anulando actividad...");

    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/cancel_assignment/${singleCancelId}`,
        null,
        {
          params: { motivo_cancelacion: cancelComment },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.dismiss(toastId);
      toast.success("Actividad anulada correctamente");

      setAssignments(prev =>
        prev.map(a =>
          a.id === singleCancelId
            ? { ...a, estado_asignaciones: 6, motivo_cancelacion: cancelComment }
            : a
        )
      );

      closeSingleCancelModal();
      setTimeout(fetchAssignments, 1000);
    } catch (error) {
      toast.dismiss(toastId);
      toast.error("Error al anular la actividad");
      console.error(error);
    }
  };

  // === EDITAR FECHAS ===
  const openEditDatesModal = (assignment) => {
    setSelectedAssignment(assignment);
    setEditDatesModalIsOpen(true);
    setNewDates({
      fechaEntregaInformacion: assignment.fecha_entrega_informacion || "",
      fechaTerminoSolicitud: assignment.fecha_termino_senior_actividad || "",
      fechaDeInicio: assignment.staff_asignado ? assignment.fecha_de_inicio || "" : "",
      fechaDeTermino: assignment.staff_asignado ? assignment.fecha_de_termino || "" : "",
    });
  };

  const closeEditDatesModal = () => {
    setEditDatesModalIsOpen(false);
    setSelectedAssignment(null);
  };

  const handleSaveDates = async () => {
    const toastId = toast.loading("Guardando fechas...");
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/update_dates/${selectedAssignment.id}`,
        null,
        {
          params: {
            fecha_entrega_informacion: newDates.fechaEntregaInformacion,
            fecha_termino_senior_actividad: newDates.fechaTerminoSolicitud,
            fecha_de_inicio: newDates.fechaDeInicio || undefined,
            fecha_de_termino: newDates.fechaDeTermino || undefined,
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.dismiss(toastId);
      toast.success("Fechas actualizadas");
      setAssignments(prev =>
        prev.map(a =>
          a.id === selectedAssignment.id
            ? {
                ...a,
                fecha_entrega_informacion: newDates.fechaEntregaInformacion,
                fecha_termino_senior_actividad: newDates.fechaTerminoSolicitud,
                fecha_de_inicio: newDates.fechaDeInicio,
                fecha_de_termino: newDates.fechaDeTermino,
              }
            : a
        )
      );
      closeEditDatesModal();
    } catch (error) {
      toast.dismiss(toastId);
      toast.error("Error al guardar fechas");
    }
  };

  // === FILTROS ===
  const filteredAssignments = assignments.filter((a) => {
    const matchesSearch = a.razon_social.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilial = !selectedFilial || a.filial === selectedFilial;
    const matchesEstado = !selectedEstadoAsignacion || a.estado_asignaciones === Number(selectedEstadoAsignacion);
    const matchesStaffState = !selectedEstadoStaff || a.estados_staff === selectedEstadoStaff;
    const matchesStaff = !selectedStaff || a.staff_asignado === selectedStaff;
    const matchesSolicitante = !selectedSolicitante || a.nombre_solicitante === selectedSolicitante;
    return matchesSearch && matchesFilial && matchesEstado && matchesStaffState && matchesStaff && matchesSolicitante;
  });

  const uniqueFiliales = [...new Set(assignments.map(a => a.filial))];
  const uniqueEstadosAsignacion = [...new Set(assignments.map(a => a.estado_asignaciones))];
  const uniqueEstadosStaff = [...new Set(assignments.map(a => a.estados_staff))];
  const uniqueStaffs = [...new Set(assignments.map(a => a.staff_asignado))].filter(Boolean);
  const uniqueSolicitantes = [...new Set(assignments.map(a => a.nombre_solicitante))].filter(Boolean);

  const allSelected = filteredAssignments.length > 0 && selectedIds.size === filteredAssignments.length;
  const someSelected = selectedIds.size > 0 && selectedIds.size < filteredAssignments.length;

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = someSelected;
    }
  }, [someSelected]);

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <div className="main-panel">
          <h1>Solicitudes Creadas - {nombre_get}</h1>
          <h2>
            Total Actividades: {filteredAssignments.length} | Seleccionadas: {selectedIds.size}
          </h2>

          {/* FILTROS */}
          <div className="filter-section">
            <label htmlFor="searchTerm">| Razón social: </label>
            <input type="text" id="searchTerm" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            <label htmlFor="filialFilter">| Filial: </label>
            <select id="filialFilter" value={selectedFilial} onChange={(e) => setSelectedFilial(e.target.value)}>
              <option value="">Todas</option>
              {uniqueFiliales.map((f, i) => <option key={i} value={f}>{f}</option>)}
            </select>
            <label htmlFor="estadoAsignacionFilter"> | Estados: </label>
            <select id="estadoAsignacionFilter" value={selectedEstadoAsignacion} onChange={(e) => setSelectedEstadoAsignacion(e.target.value)}>
              <option value="">Todos</option>
              {uniqueEstadosAsignacion.map((e, i) => <option key={i} value={e}>{e}</option>)}
            </select>
            <label htmlFor="estadoStaffFilter"> </label>
            <select id="estadoStaffFilter" value={selectedEstadoStaff} onChange={(e) => setSelectedEstadoStaff(e.target.value)}>
              <option value="">Todos</option>
              {uniqueEstadosStaff.map((e, i) => <option key={i} value={e}>{e}</option>)}
            </select>
            <label htmlFor="staffFilter"> | Staff: </label>
            <select id="staffFilter" value={selectedStaff} onChange={(e) => setSelectedStaff(e.target.value)}>
              <option value="">Todos</option>
              {uniqueStaffs.map((s, i) => <option key={i} value={s}>{s}</option>)}
            </select>
            <label htmlFor="solicitanteFilter"> | Solicitante: </label>
            <select id="solicitanteFilter" value={selectedSolicitante} onChange={(e) => setSelectedSolicitante(e.target.value)}>
              <option value="">Todos</option>
              {uniqueSolicitantes.map((s, i) => <option key={i} value={s}>{s}</option>)}
            </select>
          </div>

          {/* BOTONES DE ACCIÓN */}
          <div style={{ margin: "15px 0", display: "flex", gap: "12px", flexWrap: "wrap" }}>
            {selectedIds.size > 0 && (
              <button
                onClick={openCancelModal}
                style={{
                  backgroundColor: "#d32f2f",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Anular {selectedIds.size} seleccionada{selectedIds.size > 1 ? "s" : ""}
              </button>
            )}

          <button
              onClick={exportToExcel}
              style={{
                backgroundColor: "#14851a",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                fontWeight: "bold",
                cursor: "pointer",
                marginLeft: "auto",           // ← clave: empuja el botón a la derecha
              }}
            >
              Descargar Reporte ({filteredAssignments.length})
          </button>
          </div>

          {/* TABLA */}
          <div className="activities-table-container" style={{ overflowX: "auto" }}>
            <table className="activities-table" style={{ minWidth: "3000px" }}>
              <thead>
                <tr>
                  <th style={{ width: "50px" }}>
                    <label style={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", margin: 0, fontWeight: "bold"}}>
                      <input type="checkbox" ref={selectAllRef} checked={allSelected} onChange={toggleSelectAll} style={{ marginRight: "12px" }} />
                      Anular
                    </label>
                  </th>
                  <th>Código proyecto</th>
                  <th>Nombre proyecto</th>
                  <th>Razón Social</th>
                  <th>Filial</th>
                  <th>Tipo de trabajo</th>
                  <th>Regulación</th>
                  <th>Rubro GET</th>
                  <th>Nombre actividad GET</th>
                  <th>Grupo</th>
                  <th>Jefe de grupo</th>
                  <th>Subrogante</th>
                  <th>Fecha entrega información</th>
                  <th>Fecha término solicitud</th>
                  <th>Fecha de emisión final</th>
                  <th>Staff asignado</th>
                  <th>Nombre solicitante</th>
                  <th>Fecha de inicio</th>
                  <th>Fecha de término</th>
                  <th>Fecha corte auditoría</th>
                  <th>Horas GET</th>
                  <th>Horas estándar</th>
                  <th>Estado asignación</th>
                  <th>Estado staff</th>
                  <th>Actividad pausada</th>
                  <th>Explicación pausa</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filteredAssignments.map((a) => (
                  <tr key={a.id} style={{ backgroundColor: selectedIds.has(a.id) ? "#fff8e1" : "white" }}>
                    <td>
                      <input type="checkbox" checked={selectedIds.has(a.id)} onChange={() => toggleSelect(a.id)} />
                    </td>
                    <td>{a.codigo_proyecto}</td>
                    <td>{a.nombre_proyecto}</td>
                    <td>{a.razon_social}</td>
                    <td>{a.filial}</td>
                    <td>{a.tipo_solicitud}</td>
                    <td>{a.tipo_regulacion}</td>
                    <td>{a.rubro_get}</td>
                    <td>{a.nombre_actividad_get}</td>
                    <td>{a.numero_grupo}</td>
                    <td>{a.jefe_grupo}</td>
                    <td>{a.subrogante}</td>
                    <td>{a.fecha_entrega_informacion}</td>
                    <td>{a.fecha_termino_senior_actividad}</td>
                    <td>{a.fecha_emision}</td>
                    <td>{a.staff_asignado}</td>
                    <td>{a.nombre_solicitante}</td>
                    <td>{a.fecha_de_inicio}</td>
                    <td>{a.fecha_de_termino}</td>
                    <td>{a.fecha_corte_auditoria}</td>
                    <td>{a.horas_get}</td>
                    <td>{a.horas_estandar}</td>
                    <td>{a.estado_asignaciones}</td>
                    <td>{a.estados_staff}</td>
                    <td>{a.pausa}</td>
                    <td>{a.definicion_pausa}</td>
                    <td>
                      <button
                        onClick={() => openSingleCancelModal(a.id)}
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          border: "none",
                          padding: "8px 12px",
                          borderRadius: "5px",
                          fontSize: "12px",
                          marginRight: "5px",
                          cursor: "pointer",
                        }}
                      >
                        Anular
                      </button>

                      {a.tipo_solicitud === "Trabajo preliminar" && a.estados_staff === "No iniciada" && (
                        <button
                          onClick={() => openEditDatesModal(a)}
                          style={{
                            padding: "8px 12px",
                            fontSize: "12px",
                            cursor: "pointer",
                          }}
                        >
                          Editar Fechas
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal Anulación Masiva */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeCancelModal}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "400px",
            padding: "20px",
            borderRadius: "10px"
          }
        }}
      >
        <h2>Anular Actividad(es) Seleccionada(s)</h2>
        <p><strong>Motivo:</strong></p>
        <textarea
          value={cancelComment}
          onChange={(e) => setCancelComment(e.target.value)}
          placeholder="Escribe el motivo..."
          rows="4"
          style={{ width: "100%", padding: "8px", marginBottom: "15px", borderRadius: "5px", border: "1px solid #ccc" }}
        />
        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
          <button
            onClick={handleBulkCancel}
            style={{ backgroundColor: "#d32f2f", color: "white", padding: "10px 15px", border: "none", borderRadius: "5px", cursor: "pointer" }}
          >
            Anular
          </button>
          <button
            onClick={closeCancelModal}
            style={{ backgroundColor: "#666", color: "white", padding: "10px 15px", border: "none", borderRadius: "5px", cursor: "pointer" }}
          >
            Cancelar
          </button>
        </div>
      </Modal>

      {/* Modal Anulación Individual */}
      <Modal
        isOpen={singleCancelModalIsOpen}
        onRequestClose={closeSingleCancelModal}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "400px",
            padding: "20px",
            borderRadius: "10px"
          }
        }}
      >
        <h2>Anular Actividad</h2>
        <p><strong>Motivo de anulación:</strong></p>
        <textarea
          value={cancelComment}
          onChange={(e) => setCancelComment(e.target.value)}
          placeholder="Escribe el motivo..."
          rows="4"
          style={{ width: "100%", padding: "8px", marginBottom: "15px", borderRadius: "5px", border: "1px solid #ccc" }}
        />
        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
          <button
            onClick={handleSingleCancel}
            style={{ backgroundColor: "#d32f2f", color: "white", padding: "10px 15px", border: "none", borderRadius: "5px", cursor: "pointer" }}
          >
            Anular
          </button>
          <button
            onClick={closeSingleCancelModal}
            style={{ backgroundColor: "#666", color: "white", padding: "10px 15px", border: "none", borderRadius: "5px", cursor: "pointer" }}
          >
            Cancelar
          </button>
        </div>
      </Modal>

      {/* Modal Editar Fechas */}
      {editDatesModalIsOpen && selectedAssignment && (
        <Modal
          isOpen={editDatesModalIsOpen}
          onRequestClose={closeEditDatesModal}
          style={{
            content: { width: "400px", margin: "auto", padding: "20px" }
          }}
        >
          <h2>Editar Fechas</h2>
          <label>
            Entrega Información:
            <input
              type="date"
              value={newDates.fechaEntregaInformacion}
              onChange={e => setNewDates({ ...newDates, fechaEntregaInformacion: e.target.value })}
            />
          </label>
          <label>
            Término Solicitud:
            <input
              type="date"
              value={newDates.fechaTerminoSolicitud}
              onChange={e => setNewDates({ ...newDates, fechaTerminoSolicitud: e.target.value })}
            />
          </label>
          {selectedAssignment.staff_asignado && (
            <>
              <label>
                Inicio:
                <input
                  type="date"
                  value={newDates.fechaDeInicio}
                  onChange={e => setNewDates({ ...newDates, fechaDeInicio: e.target.value })}
                />
              </label>
              <label>
                Término:
                <input
                  type="date"
                  value={newDates.fechaDeTermino}
                  onChange={e => setNewDates({ ...newDates, fechaDeTermino: e.target.value })}
                />
              </label>
            </>
          )}
          <div style={{ marginTop: "15px", textAlign: "right" }}>
            <button
              onClick={handleSaveDates}
              style={{ backgroundColor: "#4caf50", color: "white", padding: "8px 15px", border: "none", borderRadius: "5px" }}
            >
              Guardar
            </button>
            <button
              onClick={closeEditDatesModal}
              style={{ marginLeft: "10px", backgroundColor: "#666", color: "white", padding: "8px 15px", border: "none", borderRadius: "5px" }}
            >
              Cerrar
            </button>
          </div>
        </Modal>
      )}

      <Toaster />
    </div>
  );
};

export default SolicitudesCreadasGET;